import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';

export const PipedriveIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={dimensions} height={dimensions}>
			<svg
				width={dimensions}
				height={dimensions}
				viewBox="0 0 820 304"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
			>
				<title>Pipedrive_full_logo_dark@1,5x</title>
				<desc>Created with Sketch.</desc>
				<defs>
					<polygon id="path-1" points="0 0 820 0 820 304 0 304"></polygon>
					<path
						d="M127.0461,96.3962 C127.0461,97.7153 127.5549,98.2465 128.8708,98.2465 L137.0555,98.2465 L137.0555,119.1314 L115.7823,119.1314 C107.2467,119.1314 103.264,115.0678 103.264,106.3207 L103.264,55.5118 C103.264,54.1218 102.8166,53.6703 101.4393,53.6703 L93.2546,53.6703 L93.2546,32.5995 L114.5015,32.5995 C122.9318,32.5995 127.0461,36.7959 127.0461,45.4102 L127.0461,96.3962 Z"
						id="path-3"
					></path>
					<path
						d="M184.3056,100.1951 C193.8238,100.1951 203.412,92.7849 203.412,76.1939 C203.412,61.648 195.8677,51.8828 184.639,51.8828 C175.4806,51.8828 165.6993,58.3103 165.6993,76.3621 C165.6993,87.8271 171.5417,100.1951 184.3056,100.1951 Z M189.1568,30.6438 C212.0968,30.6438 227.5187,48.8196 227.5187,75.8752 C227.5187,102.5058 211.2809,121.0977 188.0339,121.0977 C176.9631,121.0977 169.8399,116.3524 166.1467,112.9173 C166.173,113.7318 166.1993,114.6437 166.1993,115.6176 L166.1993,151.73009 L142.4084,151.73009 L142.4084,55.5126 C142.4084,54.1138 141.961,53.6712 140.5838,53.6712 L132.4078,53.6712 L132.4078,32.6003 L152.3652,32.6003 C161.5499,32.6003 163.8922,37.2749 164.3308,40.8782 C168.0766,36.6994 175.7876,30.6438 189.1568,30.6438 Z"
						id="path-5"
					></path>
					<path
						d="M254.3256,63.3859 L285.9064,63.3859 C284.9327,55.5773 279.4236,50.0794 272.2652,50.0794 C263.3524,50.0794 256.9047,54.8956 254.3256,63.3859 Z M272.2652,30.6464 C295.1087,30.6464 310.4605,47.1844 310.4605,71.7965 C310.4605,74.2931 309.9955,79.4014 309.9517,79.6139 L309.8201,81.1898 L253.4396,81.1898 C255.5011,92.6991 264.2209,100.0384 276.1339,100.0384 C288.5469,100.0384 297.9422,91.3003 298.0475,91.2206 L299.5826,89.7509 L309.9429,107.0945 L308.9867,108.0507 C308.4428,108.5819 295.6438,121.1004 274.6952,121.1004 C248.0621,121.1004 228.7363,102.0747 228.7363,75.8778 C228.7363,49.2472 246.6497,30.6464 272.2652,30.6464 Z"
						id="path-7"
					></path>
					<path
						d="M354.535,100.1951 C363.6847,100.1951 373.4747,93.7765 373.4747,75.7158 C373.4747,63.8436 367.7112,51.8828 354.8596,51.8828 C343.5256,51.8828 335.9111,61.5152 335.9111,75.8752 C335.9111,90.6425 343.2273,100.1951 354.535,100.1951 Z M396.9323,96.3971 C396.9323,97.7162 397.4411,98.2474 398.7569,98.2474 L406.7662,98.2474 L406.7662,119.1323 L386.1685,119.1323 C377.2732,119.1323 374.8783,114.4047 374.3958,110.6686 C370.7026,114.9536 363.1408,121.0977 350.026,121.0977 C327.0773,121.0977 311.6553,102.9308 311.6553,75.8752 C311.6553,49.2445 327.7527,30.6438 350.8243,30.6438 C362.6232,30.6438 369.4745,34.8491 372.9835,38.0451 L372.9835,22.9414 C372.9835,21.5426 372.5361,21.0999 371.1588,21.0999 L362.9741,21.0999 L362.9741,0.0203 L384.221,0.0203 C392.7654,0.0203 396.9323,4.2167 396.9323,12.831 L396.9323,96.3971 Z"
						id="path-9"
					></path>
					<path
						d="M459.672,31.4574 C461.5756,31.4574 463.5932,31.785 463.6634,31.8027 L465.1109,32.0506 L465.1109,55.9013 L463.1283,55.6003 C463.0932,55.5914 461.1106,55.2993 458.3824,55.2993 C450.689,55.2993 441.1796,59.5488 437.6005,71.4919 C436.4776,75.5556 435.8986,79.9468 435.8986,84.5062 L435.8986,119.1314 L412.1253,119.1314 L412.1253,55.5118 C412.1253,54.1129 411.6691,53.6703 410.2918,53.6703 L402.1159,53.6703 L402.1159,32.5995 L422.5557,32.5995 C430.9773,32.5995 435.267,36.5834 435.267,44.4274 L435.267,46.4017 C440.6708,37.2209 449.7766,31.4574 459.672,31.4574 Z"
						id="path-11"
					></path>
					<path
						d="M498.9515,96.3962 C498.9515,97.7153 499.4603,98.2465 500.7761,98.2465 L508.9696,98.2465 L508.9696,119.1314 L487.714,119.1314 C479.1608,119.1314 475.1694,115.0678 475.1694,106.3207 L475.1694,55.5118 C475.1694,54.1218 474.7307,53.6703 473.3447,53.6703 L467.204,53.6703 L467.204,32.5995 L486.4244,32.5995 C494.8547,32.5995 498.9515,36.7959 498.9515,45.4102 L498.9515,96.3962 Z"
						id="path-13"
					></path>
					<path
						d="M588.7077,32.6012 L588.7077,53.672 L585.0583,53.672 C583.1986,53.672 582.5845,54.3095 582.1459,55.4781 L558.1532,119.1332 L531.4148,119.1332 L507.4221,55.4781 C506.9835,54.3095 506.387,53.672 504.5272,53.672 L501.027,53.672 L501.027,32.6012 L514.5191,32.6012 C522.0283,32.6012 525.8706,35.1156 528.2479,41.5519 L543.7489,85.2251 C544.3366,86.8453 544.8717,88.6868 545.3191,90.4309 C545.749,88.6868 546.249,86.8718 546.7841,85.2517 L562.285,41.5608 C564.6361,35.1952 568.61,32.6012 576.0227,32.6012 L588.7077,32.6012 Z"
						id="path-15"
					></path>
					<path
						d="M611.7108,63.3859 L643.2916,63.3859 C642.3179,55.5773 636.8175,50.0794 629.6417,50.0794 C620.7376,50.0794 614.3162,54.8956 611.7108,63.3859 Z M629.6417,30.6464 C652.5027,30.6464 667.8632,47.1844 667.8632,71.7965 C667.8632,74.2931 667.3807,79.4014 667.3544,79.6139 L667.2228,81.1898 L610.8248,81.1898 C612.8863,92.6991 621.6061,100.0384 633.5279,100.0384 C645.897,100.0384 655.3449,91.3003 655.4239,91.2206 L657.0029,89.7509 L667.3369,107.0945 L666.3719,108.0507 C665.8368,108.5819 653.029,121.1004 632.0716,121.1004 C605.4385,121.1004 586.1303,102.0747 586.1303,75.8778 C586.1303,49.2472 604.0349,30.6464 629.6417,30.6464 Z"
						id="path-17"
					></path>
					<polygon id="path-19" points="104.2255 0.0265 125.4197 0.0265 125.4197 22.5581 104.2255 22.5581"></polygon>
					<polygon id="path-21" points="476.1335 0.0265 497.3365 0.0265 497.3365 22.5581 476.1335 22.5581"></polygon>
					<path
						d="M33.3002,76.3621 C33.3002,87.8271 39.1164,100.1951 51.9154,100.1951 C61.4071,100.1951 71.0042,92.7849 71.0042,76.1939 C71.0042,61.648 63.4599,51.8828 52.2312,51.8828 C43.0815,51.8828 33.3002,58.3103 33.3002,76.3621 Z M56.7402,30.6438 C79.6889,30.6438 95.1197,48.8196 95.1197,75.8752 C95.1197,102.5058 78.8643,121.0977 55.6261,121.0977 C44.5465,121.0977 37.4496,116.3524 33.7388,112.9173 C33.7652,113.7318 33.7827,114.6437 33.7827,115.6176 L33.7827,151.73009 L10.00936,151.73009 L10.00936,55.5126 C10.00936,54.1138 9.56197,53.6712 8.17592,53.6712 L0,53.6712 L0,32.6003 L19.94855,32.6003 C29.1333,32.6003 31.4843,37.2749 31.9317,40.8782 C35.66,36.6994 43.3885,30.6438 56.7402,30.6438 Z"
						id="path-23"
					></path>
				</defs>
				<g id="Pipedrive_full_logo_dark" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Pipedrive_full_logo">
						<mask id="mask-2" fill="white">
							<use xlinkHref="#path-1"></use>
						</mask>
						<g id="Background" opacity="0"></g>
						<g id="Logo" transform="translate(76.000000, 76.000000)">
							<mask id="mask-4" fill="white">
								<use xlinkHref="#path-3"></use>
							</mask>
							<use id="Clip-8" fill="#26292C" xlinkHref="#path-3"></use>
							<mask id="mask-6" fill="white">
								<use xlinkHref="#path-5"></use>
							</mask>
							<use id="Clip-11" fill="#26292C" xlinkHref="#path-5"></use>
							<mask id="mask-8" fill="white">
								<use xlinkHref="#path-7"></use>
							</mask>
							<use id="Clip-14" fill="#26292C" xlinkHref="#path-7"></use>
							<mask id="mask-10" fill="white">
								<use xlinkHref="#path-9"></use>
							</mask>
							<use id="Clip-17" fill="#26292C" xlinkHref="#path-9"></use>
							<mask id="mask-12" fill="white">
								<use xlinkHref="#path-11"></use>
							</mask>
							<use id="Clip-20" fill="#26292C" xlinkHref="#path-11"></use>
							<mask id="mask-14" fill="white">
								<use xlinkHref="#path-13"></use>
							</mask>
							<use id="Clip-23" fill="#26292C" xlinkHref="#path-13"></use>
							<mask id="mask-16" fill="white">
								<use xlinkHref="#path-15"></use>
							</mask>
							<use id="Clip-26" fill="#26292C" xlinkHref="#path-15"></use>
							<mask id="mask-18" fill="white">
								<use xlinkHref="#path-17"></use>
							</mask>
							<use id="Clip-29" fill="#26292C" xlinkHref="#path-17"></use>
							<mask id="mask-20" fill="white">
								<use xlinkHref="#path-19"></use>
							</mask>
							<use id="Clip-32" fill="#26292C" xlinkHref="#path-19"></use>
							<mask id="mask-22" fill="white">
								<use xlinkHref="#path-21"></use>
							</mask>
							<use id="Clip-35" fill="#26292C" xlinkHref="#path-21"></use>
							<mask id="mask-24" fill="white">
								<use xlinkHref="#path-23"></use>
							</mask>
							<use id="Clip-5" fill="#26292C" xlinkHref="#path-23"></use>
						</g>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

PipedriveIcon.SIZE = SIZE;
PipedriveIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};

const StyledSpan = Styled.div`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
